<template>
    <div class="loader loaderPageDetails" v-show="this.isLoading"></div> 
    <section class="Section" v-show="!this.isLoading">
        <div class="Container">
            <div class="Box">
                <div class="Frame">
                    <h1>{{ this.risorse["Backorder"] }}</h1>
                    <div class="Widget MainText">
                        <p>{{this.risorse["backorderDescr"]}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="WhiteSpace Big">&nbsp;</div>
        <div class="Container">
            <div class="Box">
                <div class="Frame">
                    <div class="AvailabilityLegend">
                        <div class="AvailabilityItem InStock">{{this.risorse["inStock"]}}</div>
                        <div class="AvailabilityItem FewPieces">{{this.risorse["lowStock"]}}</div>
                        <div class="AvailabilityItem OutOfStock">{{this.risorse["outOfStock"]}}</div>
                    </div>
                    <div class="WhiteSpace">&nbsp;</div>
                    <BackorderTable
                        :backOrderList="this.backOrderList"
                        @reload="this.Reload()"
                    />
                </div>
            </div>
            <div class="WhiteSpace Big">&nbsp;</div>
        </div>
    </section>
</template>
<script>
import BackorderTable from "@/components/BackorderTable.vue"
import {risorseMixin} from "@/mixin.js";
import BackorderService from "@/services/backorder.service.js";

export default {
    name: "Backorder",
    data(){
        return {
            backOrderList: null,
            isLoading: true
        }
    },
    components:{
        BackorderTable
    },
    mixins:[risorseMixin],
    mounted:function(){
        this.GetBackorders();
    },
    methods:{
        GetBackorders(){
            this.isLoading = true;
            BackorderService.getBackorders(this.$store.getters.getToken, this.$store.getters.getLingua).then(
                data => {
                    if(data){
                        this.backOrderList = data;
                    }
                    this.isLoading = false;
                }
            );
        },
        Reload(){
            this.GetBackorders();
        }
    }
}
</script>